import React from 'react';
import Navigation from './navigation';
import UserTable from './user-table';

export default class Admin extends React.Component {

    componentDidMount() {
        if (this.props.account === null) {
            this.props.getAccount();
        }
        if (this.props.admin.users === null) {
            this.props.getUsers();
        }
    }

    render() {
        const { admin } = this.props;
        return (
            <div>
                <Navigation {...this.props} />
                <div className="min-h-screen bg-gray-200 p-4">
                    <h2 className="text-xl font-bold my-4">All accounts</h2>
                    {admin.users !== null &&
                        <UserTable users={admin.users} />
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/admin.js